import React from 'react';

import { useNavigation } from '@react-navigation/native';
import { HeaderBackButton } from '@react-navigation/elements';

export const HeaderLeft = ({screen, secondaryScreen}) => {
	const navigation = useNavigation();
	return (
		<HeaderBackButton
			onPress={() => {
				if (secondaryScreen) navigation.navigate(screen, { screen: secondaryScreen });
				else navigation.navigate(screen);
			}}
		/>
	);
};
